import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ISPUILinkModule } from '@ispui/ng-link';

import { SvgIconModule } from 'common/svg-icon/svg-icon/svg-icon.module';

import { LinkComponent } from './link.component';

@NgModule({
  declarations: [LinkComponent],
  exports: [LinkComponent],
  imports: [CommonModule, ReactiveFormsModule, ISPUILinkModule, SvgIconModule],
})
export class LinkModule {}
